import React, { FunctionComponent } from 'react';
import styles from './Textarea.module.scss';
import { TextArea as SemanticTextArea } from 'semantic-ui-react'

export interface TextAreaProps  {
    placeholder?: string;
    onChange(event: any, data: any): void;
    value: string;
    'aria-label'?: string;
}

export const Textarea: FunctionComponent<TextAreaProps> = ({placeholder, onChange, value, 'aria-label': ariaLabel}) => {
    return (
        <SemanticTextArea className={`${styles.textarea}`} placeholder={placeholder} onChange={onChange} value={value} aria-label={ariaLabel} />
    );
}

Textarea.defaultProps = {

};